// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul {\n  padding: 0;\n  width: 780px;\n  margin: 20px auto;\n}\n\nli {\n  display: inline;\n}\n\n.tn {\n  margin: 2px 0px;\n  box-shadow: #999 1px 1px 3px 1px;\n  cursor: pointer;\n}\n\n.modal-content {\n  width: 670px !important;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
